<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "CardListDistributionPlaces",
  data: () => ({

  }),
  computed: {
    ...mapState({
      distribution_places: state => state.placesInDormitories.distribution_places,
    }),
  },
  methods: {
    ...mapActions({
      GetDetailsPlace: 'interactionStatement/GetDetailsPlace',
    }),
    transitionPlaceDetails(place){
      this.GetDetailsPlace(place.room_id)
      this.$emit('transitionPlaceDetails', {
        room_id: place.room_id,
        full_name_place: place.name_hostel + " " + place.name_room
      })
    },
    setStatusOccupancyStatus(room_info){
      if (room_info.occupied === room_info.total){
        return 'green'
      }

      return 'orange'
    }
  }
}
</script>

<template>
  <v-card
      outlined
      class="rounded-xl overflow-auto"
      width="100%"
      height="800px"
  >
    <v-card-title>
      <h6
          class="mx-auto text-caption text-uppercase text--secondary"
      >
        Список комнат
      </h6>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="4" v-for="(place, index) in distribution_places.places" :key="index">
          <v-hover class="rounded-xl" v-slot="{ hover }">
            <v-card
                @click='transitionPlaceDetails(place)'
                :elevation="hover ? 10 : 1"
                height="200px"
                outlined
                class="rounded-xl"
            >
              <v-card-title>
                <v-icon size="20px" :color="setStatusOccupancyStatus(place.room_info)">
                  fa-circle
                </v-icon>
              </v-card-title>
              <v-card-text
                  style="height: calc(100% - 47px)"
                  class="d-flex justify-center align-center"
              >
                  <v-row justify="center">
                    <v-col class="text-center text--primary text-h6" cols="12">
                      {{ place.name_hostel + " | " + place.name_room }}
                    </v-col>
                    <v-col class="text-center text-subtitle-1" cols="12">
                      {{ place.room_info.occupied }} / {{ place.room_info.total }}
                    </v-col>
                  </v-row>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style scoped>

</style>